import React from 'react';
import Icon from '@ant-design/icons';

const SupportIconSvg = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.77344 15V10C2.77344 8.01088 3.56361 6.10322 4.97014 4.6967C6.37666 3.29018 8.28431 2.5 10.2734 2.5C12.2626 2.5 14.1702 3.29018 15.5767 4.6967C16.9833 6.10322 17.7734 8.01088 17.7734 10V15M17.7734 15.8333C17.7734 16.2754 17.5978 16.6993 17.2853 17.0118C16.9727 17.3244 16.5488 17.5 16.1068 17.5H15.2734C14.8314 17.5 14.4075 17.3244 14.0949 17.0118C13.7824 16.6993 13.6068 16.2754 13.6068 15.8333V13.3333C13.6068 12.8913 13.7824 12.4674 14.0949 12.1548C14.4075 11.8423 14.8314 11.6667 15.2734 11.6667H17.7734V15.8333ZM2.77344 15.8333C2.77344 16.2754 2.94903 16.6993 3.26159 17.0118C3.57415 17.3244 3.99808 17.5 4.4401 17.5H5.27344C5.71546 17.5 6.13939 17.3244 6.45195 17.0118C6.76451 16.6993 6.9401 16.2754 6.9401 15.8333V13.3333C6.9401 12.8913 6.76451 12.4674 6.45195 12.1548C6.13939 11.8423 5.71546 11.6667 5.27344 11.6667H2.77344V15.8333Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SupportIcon = (props) => <Icon component={SupportIconSvg} {...props} />;

export default SupportIcon;
